/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../util/headers"

export const getCalculatorResult = (baseUrl, currentUser, calculatorType, calculatorId) => {
  const path = `${baseUrl}/calculator_results`
  return axios.get(path, { params: { calculator_type: calculatorType, calculator_id: calculatorId }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getDashboardResults = baseUrl => {
  const path = `${baseUrl}/calculator_results/ten_dwc_dashboard`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getDimensionResults = baseUrl => {
  const path = `${baseUrl}/calculator_results/dimension`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const getPulseDashboardResults = baseUrl => {
  const path = `${baseUrl}/calculator_results/pulse_dashboard`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const getMentalSkillsDashboardResults = baseUrl => {
  const path = `${baseUrl}/calculator_results/mental_skills_dashboard`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const getBurnoutProofDashboardResults = baseUrl => {
  const path = `${baseUrl}/calculator_results/burnout_proof_dashboard`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const getMatchfitDashboardResults = baseUrl => {
  const path = `${baseUrl}/calculator_results/matchfit_dashboard`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const getLiveLifeDashboardResults = baseUrl => {
  const path = `${baseUrl}/calculator_results/live_life_dashboard`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const getLiveLifeDashboardResultsV2 = baseUrl => {
  const path = `${baseUrl}/calculator_results/live_life_dashboard`
  return axios.get(path, headers("2"))
    .then(({ data, status }) => ({ response: data, status }))
}

export const createCalculatorResult = (baseUrl, socio_responses) => {
  const path = `${baseUrl}/calculator_results`
  return axios.post(path, { socio_responses }, headers())
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const updateCalculatorResult = (baseUrl, id, payload, is_submitted, currentUser, current_module, current_page, appVersion) => {
  const path = `${baseUrl}/calculator_results/details`
  return axios.patch(path, {
    id, payload, is_submitted, current_module, current_page
  }, headers(appVersion))
    .then(({ data, status }) => ({ response: data, status }))
}

export const initiateSectionRetake = (baseUrl, enrolmentId, section) => {
  const path = `${baseUrl}/calculator_results/section_retake`
  return axios.post(path, { enrolment_id: enrolmentId, section }, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const submitPulseCheckSurvey = (baseUrl, payload, calculatorId) => {
  const path = `${baseUrl}/calculator_results/pulse_check_submit`
  return axios.post(path, { ...payload, calculator_id: calculatorId }, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const submitBurnoutProof = (baseUrl, payload, calculatorId) => {
  const path = `${baseUrl}/calculator_results/burnout_proof_submit`
  return axios.post(path, { ...payload, calculator_id: calculatorId }, headers())
    .then(({ data, status }) => ({ response: data, status }))
}
